import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { eur } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { TrendingDown, ArrowRight } from "lucide-react";

export default function TargetAlert() {
  const { isSuperAdmin: isAdmin } = useAuth();
  const [a, setA] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    if (!isAdmin) return;
    api.get("/previsionale-alert").then((r) => setA(r.data)).catch(() => {});
  }, [isAdmin]);
  if (!a?.has_target || !a.below) return null;
  const pctTxt = a.scostamento_pct == null ? "" : ` (${String(a.scostamento_pct).replace(".", ",")}%)`;
  return (
    <button data-testid="target-alert" onClick={() => navigate("/previsionale")}
      className="mb-6 w-full text-left flex flex-wrap items-center gap-2 text-sm rounded-md border border-red-200 bg-red-50 text-red-700 px-3 py-2.5 hover:bg-red-100 transition-colors">
      <TrendingDown size={16} />
      <span><b>Sotto obiettivo {a.year}:</b> netto da inizio anno {eur(a.ytd_netto)} contro {eur(a.ytd_target)} previsti a oggi, scostamento <b>{eur(a.scostamento)}{pctTxt}</b>.</span>
      <span className="ml-auto inline-flex items-center gap-1 font-semibold">Apri Previsionale <ArrowRight size={14} /></span>
    </button>
  );
}
